let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3Prkl")).then(() => parcelRequire('kelPQ'));